import React, { useEffect, useState } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { translate } from "../locales/translate";

import Theme from "../argon-ui/Theme";
import SmartParking, {
  ParkingArea,
  ReservedModel,
} from "../viewModels/SmartParking";
import { IconButton } from "../components_v2/Buttons";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import axios from "axios";
import Loading from "../components/Loading";
import PersianCalendar from "../components/PersianCalendar";
import { TouchableHighlight } from "react-native-gesture-handler";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
let moment = require("moment-jalaali");
const HIDE_RESEND_SMS = 5 * 60 * 1000;
const HIDE_MESSAGE_ERROR = 6 * 1000;
const ParkingReservationListScreen = (props: any) => {
  // TODO get reserved List
  // url : url/smartparking/reservedList
  // parameter=> parikingId
  const [loading, setLoading] = useState<boolean>(true);
  const serverUrl = props.appReducer.serverUrl;
  const accessToken = props.appReducer?.currentServer.accessToken;
  const [filterDate, setFilterDate] = useState<string>(
    new Date().toISOString()
  );
  const [toggleCalendar, setToggleCalendar] = useState<boolean>(false);
  useEffect(() => {
    getReservedList(
      serverUrl,
      accessToken,
      props.navigation.state.params.parkingAreaId,
      filterDate
    );
    setLoading(true);
  }, [props.navigation.state.params.parkingAreaId, filterDate]);
  // === get reserved List ===
  const getReservedList = (
    serverUrl: string,
    accessToken: string,
    parkingAreaId: string,
    date: string
  ) => {
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
    if (serverUrl && !serverUrl.endsWith("/")) {
      serverUrl += "/";
    }
    axios
      .get(
        `${serverUrl}SmartParking/ReservedList?parkingAreaId=${parkingAreaId}&date=${date}`,
        config
      )
      .then((res) => {
        setReserveParking(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const dateJalaali = moment(filterDate).format("jYYYY/jM/jD");

  const [reserveParking, setReserveParking] = useState<ReservedModel[] | []>(
    []
  );
  // === Sort By starTime ===
  const sortReservedList = reserveParking.sort(function (a, b) {
    return (
      Date.parse(a.startTime.slice(0, -3) + a.startTime.slice(-2)) -
      Date.parse(b.startTime.slice(0, -3) + b.startTime.slice(-2))
    );
  });
  const [smartParking, setSmartParking] = useState<SmartParking[] | []>(
    props.AreaReducer.parkings
  );
  return (
    <View style={{ flex: 1 }}>
      <View style={[styles.wrapper, { margin: 5 }]}>
        <TouchableHighlight
          underlayColor={Theme.COLORS.PRIMARY}
          onPress={() => {
            setToggleCalendar(!toggleCalendar);
          }}
          style={{
            padding: 10,
            borderRadius: 10,
            backgroundColor: Theme.COLORS.THIRED,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                width: "90%",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                style={{ marginHorizontal: 3 }}
                icon={faCharCodes.faCalendar}
                size={16}
                color={Theme.COLORS.BLACK}
              />
              <Text style={{ marginHorizontal: 8 }}>
                {translate("smartParking.reserveDateList")} :
              </Text>
              <Text
                style={{
                  marginHorizontal: 5,
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                {dateJalaali}
              </Text>
            </View>
            {/* === Btn toggle calendar container === */}
            <View
              style={{
                width: "10%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 5,
                  justifyContent: "center",
                  alignItems: "center",
                }}
                // onPress={() => {
                //   setToggleCalendar(!toggleCalendar);
                // }}
                icon={{
                  code: "\uf044",
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 18,
                    color: Theme.COLORS.BLACK,
                  },
                }}
              />
            </View>
          </View>
        </TouchableHighlight>
        {toggleCalendar && (
          <View style={{ marginTop: 10 }}>
            <PersianCalendar
              minDate={new Date()}
              onDateChange={(text) => {
                setToggleCalendar(false);
                setFilterDate(new Date(text._d).toISOString());
              }}
            />
          </View>
        )}
      </View>
      {loading ? (
        <View style={{ flex: 1 }}>
          <Loading />
        </View>
      ) : reserveParking.length == 0 ? (
        <View
          style={{ flex: 1, justifyContent: "center", alignContent: "center" }}
        >
          <Text
            style={{ fontSize: 15, fontWeight: "bold", textAlign: "center" }}
          >
            {translate("app.emptyList")}
          </Text>
        </View>
      ) : (
        <ScrollView style={{ padding: 5 }}>
          {sortReservedList.map((item: ReservedModel, i: number) => {
            return (
              <ReserveItem
                key={i}
                item={item}
                smartParking={smartParking}
                navigation={props.navigation}
                accessToken={accessToken}
                serverUrl={serverUrl}
              />
            );
          })}
        </ScrollView>
      )}
    </View>
  );
};

const ReserveItem = (props: any) => {
  const { item, smartParking, navigation, serverUrl, accessToken } = props;
  const [statusParkingReserve, setStatusParkingReserve] = useState(item.state);
  const parkingName = item.parkingFullName.split(",");
  const [openDropDown, setOpenDropDown] = useState<boolean>(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const findSmartParking = smartParking.find((i: SmartParking) => {
    return i.id === navigation.state.params.smartParkingId;
  });
  const findParkingArea = findSmartParking?.parkingAreas.find(
    (i: ParkingArea) => {
      return i.id === navigation.state.params.parkingAreaId;
    }
  );
  const [inactiveMode, setInactiveMode] = useState(
    item.state === "Canceled" ? true : false
  );
  const [forbidError, setForbidError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const deleteReserveRequest = (serverUrl: string, body: Object) => {
    if (serverUrl && !serverUrl.endsWith("/")) {
      serverUrl += "/";
    }
    axios
      .post(`${serverUrl}SmartParking/CancelReserve`, body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        response.status == 200
          ? setInactiveMode(true)
          : response.status == 403
          ? setForbidError(true)
          : setErrorMessage(true);
        setStatusParkingReserve("Canceled");
        // console.log(response);
      })
      .catch((error) => {
        console.log("error delete reserve", error);
      });
  };
  const resendSmsRequest = (serverUrl: string, reserveId: string) => {
    if (serverUrl && !serverUrl.endsWith("/")) {
      serverUrl += "/";
    }
    axios
      .get(`${serverUrl}SmartParking/SendInvitationLink/${reserveId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setShowModalResendSms(false);
        setHideResendSms(false);
        setMessageResendSms(translate("app.successResendSms"));
        setInterval(() => {
          setMessageResendSms("");
        }, HIDE_MESSAGE_ERROR);
        setInterval(() => {
          setHideResendSms(true);
        }, HIDE_RESEND_SMS);
        // response.status == 200
        // console.log(response);
      })
      .catch((error) => {
        setShowModalResendSms(false);
        console.log("error delete reserve", error);
        setMessageResendSms(translate("app.failedResendSms"));
        setInterval(() => {
          setMessageResendSms("");
        }, HIDE_MESSAGE_ERROR);
      });
  };

  // Valid = 0, // is ready to use  => statusColor:green #2DCE89
  // TooEarly = 1, // current time is less than start time StatusColor: yellow #ff8400
  // Expired = 2, // current time is passed end time => StatusColor:red #f5365c
  // InUse = 3, // car is parked in lot => StatusColor: yellow #ff8400
  // Released = 4, // car left the parking lot
  // UnKnown = 5 // unknown situation
  // const dataParkingStatus = [
  //   {
  //     label: translate("smartParking.parkingStatusList.Available"),
  //     value: "Available",
  //   },
  //   {
  //     label: translate("smartParking.parkingStatusList.Occupying"),
  //     value: "Occupying",
  //   },
  //   {
  //     label: translate("smartParking.parkingStatusList.Occupied"),
  //     value: "Occupied",
  //   },
  //   {
  //     label: translate("smartParking.parkingStatusList.OutOfService"),
  //     value: "OutOfService",
  //   },
  //   {
  //     label: translate("smartParking.parkingStatusList.Reserved"),
  //     value: "Reserved",
  //   },
  //   {
  //     label: translate("smartParking.parkingStatusList.Expired"),
  //     value: "Expired",
  //   },
  //   {
  //     label: translate("smartParking.parkingStatusList.TooEarly"),
  //     value: "TooEarly",
  //   },
  // ];
  // const translateStatus = dataParkingStatus.find((i) => {
  //   return i.value == item.state && i.label;
  // });

  // === delete handler ===
  const deleteHandler = (id: string) => {
    setShowModalDelete(false);
    const body = {
      id,
    };
    deleteReserveRequest(serverUrl, body);
  };
  // === Resend Sms  ===
  const [showModalResendSms, setShowModalResendSms] = useState(false);
  const [messageResendSms, setMessageResendSms] = useState("");
  const [hideResendSms, setHideResendSms] = useState(true);
  const resendSmsHandler = (reserveId: string) => {
    resendSmsRequest(serverUrl, reserveId);
  };
  return (
    <View
      style={[
        styles.wrapper,
        inactiveMode && { backgroundColor: Theme.COLORS.INPUT },
      ]}
    >
      <View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            padding: 10,
            position: "relative",
          }}
        >
          {((!openDropDown &&
            !inactiveMode &&
            statusParkingReserve == "Expired") ||
            statusParkingReserve == "Valid" ||
            statusParkingReserve == "Occupied") && (
            <View
              style={[
                {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: 8,
                  height: 8,
                  borderRadius: 5,
                },
                item.state === "Valid"
                  ? { backgroundColor: Theme.COLORS.SUCCESS }
                  : item.state === "InUse" || item.state === "TooEarly"
                  ? { backgroundColor: Theme.COLORS.ORANGE }
                  : { backgroundColor: Theme.COLORS.ERROR },
              ]}
            />
          )}
          <View
            style={[
              {
                // width: "90%",
                // width: "70%"
              },
              inactiveMode || statusParkingReserve == "Expired"
                ? { width: "90%" }
                : { width: "80%" },
            ]}
          >
            {/* === name === */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 12,
              }}
            >
              <FontAwesomeIcon
                icon={faCharCodes.faUser}
                size={16}
                color={Theme.COLORS.MUTED}
              />
              <Text style={{ marginHorizontal: 8 }}>
                {translate("smartParking.reservation.fullNameGuest")}
                {" : "}
                {item.user === "admin"
                  ? translate("user.role.admin")
                  : item.user}
              </Text>
            </View>
            {/* === PhoneNumber === */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faCharCodes.faPhone}
                size={16}
                color={Theme.COLORS.MUTED}
              />
              <Text style={{ marginHorizontal: 8 }}>
                {translate("smartParking.reservation.phoneNumber")}
                {" : "}
                {"0" + item.userPhoneNumber}
              </Text>
            </View>
            {/* === Date Reserved === */}
            {/* <Text>
              {`${translate(
                "smartParking.reservation.dateReserve"
              )} : ${dateJalaali}`}
            </Text> */}
          </View>
          <View
            style={[
              {
                flexDirection: "row",
                alignItems: "center",
              },
              inactiveMode || statusParkingReserve == "Expired"
                ? { width: "10%" }
                : { width: "20%" },
            ]}
          >
            <IconButton
              style={{
                width: 30,
                height: 30,
                borderRadius: 20,
                justifyContent: "center",
                alignItems: "center",
                marginHorizontal: 3,
              }}
              onPress={() => setOpenDropDown(!openDropDown)}
              // onPress={() => setOpenDropDown(!openDropDown)}
              icon={{
                code: !openDropDown ? "\uf0d7" : "\uf0d8",
                style: {
                  fontFamily: "FontAwesomeProLight",
                  fontSize: 16,
                  color: Theme.COLORS.BLACK,
                },
              }}
            />
            {/* === Delete Btn === */}
            {statusParkingReserve !== "Expired" &&
              statusParkingReserve !== "Canceled" && (
                <IconButton
                  style={{
                    backgroundColor: "#fee6eb",
                    width: 35,
                    height: 35,
                    borderRadius: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    marginHorizontal: 4,
                  }}
                  onPress={() => setShowModalDelete(true)}
                  icon={{
                    code: "\uf1f8",
                    style: {
                      fontFamily: "FontAwesomeProLight",
                      fontSize: 16,
                      color: Theme.COLORS.ERROR,
                    },
                  }}
                />
              )}
            {/* === Edit Btn === */}
            {/* <IconButton
              style={{
                width: 30,
                height: 30,
                borderRadius: 20,
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={() =>
                navigation.navigate("ParkingResevetionForm", {
                  smartParking: findParkingArea,
                  reservedData: item,
                  showParkingReserved: true,
                  editMode: true,
                })
              }
              icon={{
                code: "\uf044",
                style: {
                  fontFamily: "FontAwesomeProLight",
                  fontSize: 16,

                  // color: Theme.COLORS.WHITE,
                },
              }}
            /> */}
          </View>
        </View>
        {openDropDown && (
          <View
            style={[
              styles.wrapper,
              {
                backgroundColor: Theme.COLORS.PRIMARY,
                padding: 10,
                shadowColor: Theme.COLORS.PRIMARY,
              },
            ]}
          >
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              {/* === Time === */}
              <View style={[styles.itemDropDown, { width: "50%" }]}>
                <FontAwesomeIcon
                  icon={faCharCodes.faClock}
                  size={15}
                  color={Theme.COLORS.WHITE}
                />
                <Text style={styles.txtWhite}>
                  {" "}
                  {`${translate("smartParking.reservation.startTime")} : ${
                    item.startTime
                  }`}
                </Text>
              </View>
              <View style={[styles.itemDropDown, { width: "50%" }]}>
                <FontAwesomeIcon
                  icon={faCharCodes.faClock}
                  size={15}
                  color={Theme.COLORS.WHITE}
                />
                <Text style={styles.txtWhite}>
                  {" "}
                  {`${translate("smartParking.reservation.endTime")} : ${
                    item.endTime
                  }`}
                </Text>
              </View>
              {/* === SmartParking Name === */}
              <View style={styles.itemDropDown}>
                <FontAwesomeIcon
                  icon={faCharCodes.faBuilding}
                  size={15}
                  color={Theme.COLORS.WHITE}
                />
                <Text style={styles.txtWhite}>
                  {" "}
                  {`${translate("smartParking.reservation.building")} : ${
                    parkingName[0]
                  }`}
                </Text>
              </View>
              {/* === ParkingArea Name === */}
              <View style={styles.itemDropDown}>
                <FontAwesomeIcon
                  icon={faCharCodes.faBuilding}
                  size={15}
                  color={Theme.COLORS.WHITE}
                />
                <Text style={styles.txtWhite}>
                  {`${translate("smartParking.reservation.floor")} : ${
                    parkingName[1]
                  }`}
                </Text>
              </View>
              {/* === ParkingLot Name === */}
              <View style={styles.itemDropDown}>
                <FontAwesomeIcon
                  icon={faCharCodes.faParkingCircle}
                  size={15}
                  color={Theme.COLORS.WHITE}
                />
                <Text style={styles.txtWhite}>
                  {translate("smartParking.reservation.parking")} :{" "}
                  {parkingName[2]}
                </Text>
              </View>
              {(statusParkingReserve == "Expired" ||
                statusParkingReserve == "Canceled" ||
                statusParkingReserve == "Valid" ||
                statusParkingReserve == "Occupied") && (
                <View style={[styles.itemDropDown]}>
                  {((!inactiveMode && statusParkingReserve == "Expired") ||
                    statusParkingReserve == "Occupied" ||
                    statusParkingReserve == "Valid") && (
                    <View
                      style={[
                        { width: 10, height: 10, borderRadius: 5 },
                        item.state === "Valid"
                          ? { backgroundColor: Theme.COLORS.SUCCESS }
                          : item.state === "InUse" || item.state === "TooEarly"
                          ? { backgroundColor: Theme.COLORS.ORANGE }
                          : { backgroundColor: Theme.COLORS.ERROR },
                      ]}
                    />
                  )}
                  <Text style={styles.txtWhite}>
                    {translate("smartParking.parkingStatus")} :{" "}
                    {translate(
                      `smartParking.parkingStatusList.${statusParkingReserve}`
                    )}
                  </Text>
                </View>
              )}
              {/* === Resend SMS === */}
              {statusParkingReserve !== "Expired" &&
                statusParkingReserve !== "Canceled" &&
                hideResendSms && (
                  <View
                    style={{
                      // position: "absolute",
                      // bottom: 0,
                      // right: 0,
                      // minWidth: 35,
                      // height: 35,
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      marginVertical: 5,
                    }}
                  >
                    <TouchableHighlight
                      containerStyle={{
                        borderRadius: 10,
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: 40,
                        backgroundColor: Theme.COLORS.SUCCESS,
                      }}
                      underlayColor={"transparent"}
                      onPress={() => setShowModalResendSms(true)}
                    >
                      <View
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          // marginHorizontal: 4,
                          flexDirection: "row",
                        }}
                      >
                        <Text
                          style={{
                            color: Theme.COLORS.WHITE,
                            marginHorizontal: 8,
                          }}
                        >
                          {translate("smartParking.resendSmsCode")}
                        </Text>
                        <IconButton
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 20,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onPress={() =>
                            navigation.navigate("ParkingResevetionForm", {
                              smartParking: findParkingArea,
                              reservedData: item,
                              showParkingReserved: true,
                              editMode: true,
                            })
                          }
                          icon={{
                            code: "\uf27a",
                            style: {
                              fontFamily: "FontAwesomeProLight",
                              fontSize: 16,
                              color: Theme.COLORS.WHITE,
                            },
                          }}
                        />
                      </View>
                    </TouchableHighlight>
                  </View>
                )}
              {messageResendSms !== "" && (
                <View style={{ width: "100%", marginVertical: 5 }}>
                  <Text
                    style={{ color: Theme.COLORS.WHITE, textAlign: "center" }}
                  >
                    {messageResendSms}
                  </Text>
                </View>
              )}
            </View>
          </View>
        )}
        {/* === Delete modal === */}
        {showModalDelete && (
          <AlertDialogBase
            isOpen={showModalDelete}
            title={item.phoneNumber}
            confirmText={translate("app.sendSms")}
            confirmHandler={() => {
              deleteHandler(item.id);
            }}
            onClose={() => setShowModalDelete(false)}
          >
            <Text>
              {translate("smartParking.deleteReservationMessage", {
                user:
                  item.user === "admin"
                    ? translate("user.role.admin")
                    : item.user,
                parkingName: parkingName[2],
              })}
            </Text>
          </AlertDialogBase>
        )}
        {/* === Resend Sms Modal === */}
        {showModalResendSms && (
          <AlertDialogBase
            isOpen={showModalResendSms}
            title={item.phoneNumber}
            confirmText={translate("app.sendSms")}
            confirmHandler={() => {
              resendSmsHandler(item.id);
            }}
            onClose={() => setShowModalResendSms(false)}
          >
            <Text>
              {translate("smartParking.deleteReservationMessage", {
                user:
                  item.user === "admin"
                    ? translate("user.role.admin")
                    : item.user,
                parkingName: parkingName[2],
              })}
            </Text>
          </AlertDialogBase>
        )}
      </View>
    </View>
  );
};
const mapStateToProps = (state: any) => {
  return {
    reducer: state.ScenarioReducer,
    AreaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};
const styles = StyleSheet.create({
  wrapper: {
    marginVertical: 5,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Theme.COLORS.GRAY_LIGHT,

    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
    // borderColor: "#e4e4e4",
    // borderWidth: 1,
    // maxWidth: CONSTANTS.WEB_MAX_WIDTH - 30,
  },
  txtWhite: {
    color: Theme.COLORS.WHITE,
    fontSize: 15,
    marginHorizontal: 5,
  },
  txtBlack: {
    color: Theme.COLORS.BLACK,
    fontSize: 15,
    marginHorizontal: 5,
  },
  itemDropDown: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    marginVertical: 10,
  },
});
// const mapDispatchToProps = (dispatch) => {
//   return {
//     removeScenario: (scenarioId, accessToken) =>
//       dispatch(Actions.Remove(scenarioId, accessToken)),
//     runScenario: (scenarioId, accessToken) =>
//       dispatch(Actions.RunScenario(scenarioId, accessToken)),
//     toggleEnable: (scenarioId, enable, accessToken) =>
//       dispatch(Actions.ToggleEnable(scenarioId, enable, accessToken)),
//     getDetails: (scenarioId, accessToken) =>
//       dispatch(Actions.GetDetails(scenarioId, accessToken)),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(ParkingListScreen);
ParkingReservationListScreen["navigationOptions"] = ({
  screenProps: { translate },
}: any) => ({
  headerTitle: translate("navigation.ParkingReservationList"),
});
export default connect(
  mapStateToProps,
  null
)(React.memo(ParkingReservationListScreen));
